import { differenceInHours } from "date-fns";
import { SIDE_LIST_BACKGROUND, SELECT_GREEN } from "./Const";

export function getSideBgColour(isSelected: boolean, dragUnderway: boolean, isDragged: boolean, isOver: boolean, canDrop: boolean): string {
  if (dragUnderway && !isDragged) {
    if (canDrop && isOver) {
      return hexToRGB(SELECT_GREEN, 0.6);
    } else if (canDrop) {
      return hexToRGB(SELECT_GREEN, 0.2);
    }
  }
  if ((!dragUnderway && isSelected) || isDragged) {
    return hexToRGB(SELECT_GREEN, 0.4);
  }
  return SIDE_LIST_BACKGROUND;
}

export function hexToRGB(hex: string, alpha: number): string {
  const { r, g, b } = parseHexColor(hex);

  if (alpha !== undefined) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}
export function brightenHexColor(hex: string, amount: number, alpha: number): string {
  if (!alpha) {
    alpha = 1;
  }
  let { r, g, b } = parseHexColor(hex);
  r = Math.min(r + amount, 255);
  g = Math.min(g + amount, 255);
  b = Math.min(b + amount, 255);
  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
}

export function parseHexColor(hex: string): {r: number, g: number, b: number} {
  let r: number;
  let g: number;
  let b: number;
  if (hex.length === 4) {
    //Using shorthand notation;
    r = parseInt(hex.slice(1, 2), 16);
    g = parseInt(hex.slice(2, 3), 16);
    b = parseInt(hex.slice(3, 4), 16);
    r = r * 16 + r;
    g = g * 16 + g;
    b = b * 16 + b;
  } else {
    r = parseInt(hex.slice(1, 3), 16);
    g = parseInt(hex.slice(3, 5), 16);
    b = parseInt(hex.slice(5, 7), 16);
  }
  return { r, g, b };
}

export function getChartTotalWidth(hourWidth: number, startDate: Date, endDate: Date): number {
  return hourWidth * differenceInHours(endDate, startDate);
}

// Following 2 functions are picked from stackoverflow and modified to typescript
// https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color

export function pickTextColorBasedOnBgColorSimple(bgColor: string, lightColor: string, darkColor: string): string {
  const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB
  return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
    darkColor : lightColor;
}

export function pickTextColorBasedOnBgColorAdvanced(bgColor: string, lightColor: string, darkColor: string): string {
  const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB
  const uicolors = [r / 255, g / 255, b / 255];
  const c = uicolors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92;
    }
    return Math.pow((col + 0.055) / 1.055, 2.4);
  });
  const L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
  return (L > 0.179) ? darkColor : lightColor;
}